// extracted by mini-css-extract-plugin
export default {"homeSecondSection":"styles_homeSecondSection__LwFwY","wrapper":"styles_wrapper__79Byx","bgImgWrapper":"styles_bgImgWrapper__Zb2p3","contentWrapper":"styles_contentWrapper__pIIQx"};